import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';

@Component({
    selector: 'app-success-dialog',
    templateUrl: './success-dialog.component.html',
    styleUrls: ['./success-dialog.component.css'],
    standalone: false
})
export class SuccessDialogComponent implements OnInit {
  constructor(
    private dialogRef: MatDialogRef<SuccessDialogComponent>,
    private router: Router,
    @Inject(MAT_DIALOG_DATA) public data: { title?: string; message?: string }
  ) {}

  ngOnInit(): void {
    setTimeout(() => {
      this.dialogRef.close();
      this.router.navigate(['/pedidospendiente']);
    }, 2000);
  }

  close() {
    this.dialogRef.close();
    this.router.navigate(['/pedidospendiente']);
  }
}


